import React from 'react';
import UsersList from './users/UsersList';

const UsersPage: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <UsersList />
    </div>
  );
};

export default UsersPage;
